import { createI18n } from 'vue-i18n'
import en from '@/locales/en'
import fr from '@/locales/fr'
import pt from '@/locales/pt'
import sw from '@/locales/sw'

const getLang = () => {
  const lang = navigator.language.substring(0, 2)
  return ['en', 'fr', 'pt', 'sw'].includes(lang) ? lang : 'en'
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getLang(),
  messages: { en, fr, pt, sw }
})

export default i18n
